import { useFixedAuthApi } from "@/contexts/authenticated-api/AuthOrLoadingProvider";
import { ABSOLUTELY_NO_REFRESH } from "@/utils/query-settings/queryOptions";

// Type definition for subscription fees response
export interface SubscriptionFee {
  currency: string;
  id: string;
  label: string;
  price: number;
}

export interface SubscriptionFeesResponse {
  fees: SubscriptionFee[];
}

/**
 * Custom React hook to fetch subscription fees from the API
 * @returns Query result containing subscription fees data and loading/error states
 */
function useSubscriptionFees() {
  const $api = useFixedAuthApi();

  const { data, isError, isLoading } = $api.useQuery(
    "get",
    "/subscriptions/fees",
    {},
    ABSOLUTELY_NO_REFRESH,
  );

  return { data, isError, isLoading };
}

export { useSubscriptionFees };
